import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthHttpService } from '@core/entity/auth/service/auth.http.service';
import { PlatformService } from '@core/services/platform.service';
import { UrlService } from '@core/services/url.service';

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const
    authHttpService = inject(AuthHttpService),
    urlService = inject(UrlService),
    router = inject(Router),
    platformService = inject(PlatformService);

  if (platformService.isBrowser()) {
    console.debug('Authorized to access member route: ' + authHttpService.getLoginStatus());
    if (!authHttpService.getLoginStatus()) {
      let routeTo: string;

      if (urlService.getPreviousUrl()) {
        routeTo = urlService.getPreviousUrl();;
      } else {
        routeTo = '/home';
      }
      console.debug('Routing to : ' + routeTo);
      router.navigate([routeTo]);
      return false;
    }
    return true;
  } else {
    return false;
  }
};
